import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import OAMasterListing from "../../../components/SidebarMenuComponents/OAComponent/OAMasterListing";
import StickyHeader from "../../../components/Common/StickyHeader";
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function OAMasterListingPage() {
    const location = useLocation();
    const oaMaster = location.state;
    return (
        <Page title="  OA Master Listing | tiketic" >
          
            <StickyHeader title=" OA Master Listing" />

            <ContentStyle>
                <OAMasterListing oaMaster={oaMaster} />
            </ContentStyle>
        </Page>
    );
}

